module.exports = __webpack_public_path__ + "img/D201608_4.2ceda0b8.jpg";